import { render, staticRenderFns } from "./MesaInfo.vue?vue&type=template&id=60875b8a&"
import script from "./MesaInfo.vue?vue&type=script&lang=js&"
export * from "./MesaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports